import { useEffect } from "react";
import { useRoute, navigate } from "./router.js";
import { Layout } from "./components/Layout.js";
import { Home } from "./pages/Home.js";
import { Calendar } from "./pages/Calendar.js";
import { CalendarGrid } from "./pages/CalendarGrid.js";
import { OpenHares } from "./pages/OpenHares.js";
import { NotFound } from "./pages/NotFound.js";
import { track } from "./lib/track.js";

function pathFor(kind: string): string {
  switch (kind) {
    case "home": return "/";
    case "calendar": return "/calendar";
    case "calendar-grid": return "/calendar/month";
    case "open-hares": return "/open-hares";
    default: return "/";
  }
}

export function App() {
  const route = useRoute();
  useEffect(() => {
    // Fire once on app boot if this load is the installed PWA running in
    // standalone mode (home-screen launch). Detected via the
    // display-mode media query the browser exposes for installed PWAs.
    if (window.matchMedia("(display-mode: standalone)").matches) {
      track("standalone_load");
    }
    // Fires once when the user actually accepts the install prompt
    // (Chrome / Edge / Android). iOS Safari doesn't fire this — there's no
    // server-visible signal for "Add to Home Screen" on iOS.
    const onInstalled = () => track("app_installed");
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);
  return (
    <Layout currentPath={pathFor(route.kind)} onNavigate={navigate}>
      {route.kind === "home" && <Home />}
      {route.kind === "calendar" && <Calendar />}
      {route.kind === "calendar-grid" && <CalendarGrid />}
      {route.kind === "open-hares" && <OpenHares />}
      {route.kind === "not-found" && <NotFound path={route.path} />}
    </Layout>
  );
}
